(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloque-productos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carruseles = document.querySelectorAll('.glash-showcase-col-carrusel');
    
    carruseles.forEach(carrusel => {
      const pista = carrusel.querySelector('.glash-showcase-pista');
      const btnIzq = carrusel.querySelector('.glash-showcase-flecha-izq');
      const btnDer = carrusel.querySelector('.glash-showcase-flecha-der');
      
      if (!pista) return;

      const verificarVisibilidadFlechas = () => {
        const tolerancia = 5;
        const scrollMaximo = pista.scrollWidth - pista.clientWidth;

        if (pista.scrollLeft <= tolerancia) {
          if (btnIzq) btnIzq.classList.add('oculto');
        } else {
          if (btnIzq) btnIzq.classList.remove('oculto');
        }

        if (pista.scrollLeft >= (scrollMaximo - tolerancia)) {
          if (btnDer) btnDer.classList.add('oculto');
        } else {
          if (btnDer) btnDer.classList.remove('oculto');
        }
      };

      if (btnDer) {
        btnDer.addEventListener('click', (e) => {
          e.preventDefault();
          const tarjeta = pista.querySelector('.glash-showcase-tarjeta');
          if (tarjeta) {
            const avance = (tarjeta.offsetWidth + 20) * 2;
            pista.scrollBy({ left: avance, behavior: 'smooth' });
          }
        });
      }

      if (btnIzq) {
        btnIzq.addEventListener('click', (e) => {
          e.preventDefault();
          const tarjeta = pista.querySelector('.glash-showcase-tarjeta');
          if (tarjeta) {
            const retroceso = (tarjeta.offsetWidth + 20) * 2;
            pista.scrollBy({ left: -retroceso, behavior: 'smooth' });
          }
        });
      }

      pista.addEventListener('scroll', verificarVisibilidadFlechas);
      window.addEventListener('resize', verificarVisibilidadFlechas);
      setTimeout(verificarVisibilidadFlechas, 300);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
